/**
 * JS Code um die Folgen Button Klickbar zu machen
 * Prototype: Iww.NodeTypes:Components.Atoms.Tasten.Folgen
 */

import { getAutorGefolgt, getInformationsdienstGefolgt, getThemaGefolgt, removeAutorGefolgt, removeInformationsdienstGefolgt, removeThemaGefolgt, setAutorGefolgt, setInformationsdienstGefolgt, setThemaGefolgt } from "./ApiCalls";

FolgenButtonAktivieren("infodienst", getInformationsdienstGefolgt, setInformationsdienstGefolgt, removeInformationsdienstGefolgt);
FolgenButtonAktivieren("autor", getAutorGefolgt, setAutorGefolgt, removeAutorGefolgt);
FolgenButtonAktivieren("thema", getThemaGefolgt, setThemaGefolgt, removeThemaGefolgt);

function FolgenButtonAktivieren(name, getFunction, setFunction, removeFunction) {
  const folgenButton = document.getElementById(name + "_folgen");
  const folgenButtonDisabled = document.getElementById(name + "_folgen_disabled");

  document.addEventListener('DOMContentLoaded', () => {
    if (folgenButton) {
      const id = folgenButton.dataset.id;
      getFunction(id).then(res => {
        if (res === null || res === false || res.length == 0) {
          return;
        }

        folgenButton.classList.add("hidden");
        folgenButtonDisabled.classList.remove("hidden");
      });
    }
  });


  if (folgenButton !== null && folgenButtonDisabled !== null) {
    folgenButton.addEventListener("click", event => {
      const id = folgenButton.dataset.id;
      setFunction(id).then(res => {
        if (res == null) { return; }

        folgenButton.classList.add("hidden");
        folgenButtonDisabled.classList.remove("hidden");
      });
    });

    folgenButtonDisabled.addEventListener("click", event => {
      const id = folgenButtonDisabled.dataset.id;
      removeFunction(id).then(res => {
        if (res == null) { return; }

        folgenButton.classList.remove("hidden");
        folgenButtonDisabled.classList.add("hidden");
      });
    });

    folgenButtonDisabled.addEventListener("mouseenter", event => {
      folgenButtonDisabled.classList.remove("before:content-checkmark");
      folgenButtonDisabled.classList.add("before:content-close");
      folgenButtonDisabled.innerText = "Entfolgen";
    });

    folgenButtonDisabled.addEventListener("mouseleave", event => {
      folgenButtonDisabled.classList.remove("before:content-close");
      folgenButtonDisabled.classList.add("before:content-checkmark");
      folgenButtonDisabled.innerText = "Gefolgt";
    });
  }

}